import catalog from './glyphs.json';
import ui from './ui-glyphs.json';
export const glyphs = catalog;
export const uiGlyphs = ui;
